import { render, staticRenderFns } from "./RecBalanceBack.vue?vue&type=template&id=7bab4630"
import script from "./RecBalanceBack.vue?vue&type=script&lang=js"
export * from "./RecBalanceBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports